import { PriceType, ProductType } from '@wix/ambassador-forms-v4-form/types';
import { generateUUID } from '@wix/form-schema';
import { localizeNumberInput } from '../shared/numeric-input-utils';
export function toProductValue(product, value) {
  return {
    productId: product.id,
    price: value,
    quantity: 1
  };
}
export function aFixedPricePayment(id, price) {
  if (id === void 0) {
    id = generateUUID();
  }
  if (price === void 0) {
    price = '10';
  }
  return {
    id,
    priceType: PriceType.FIXED_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: {
      minimum: 1,
      maximum: 1
    },
    fixedPriceOptions: {
      price
    }
  };
}
export function aDynamicPricePayment(id, min, max) {
  if (id === void 0) {
    id = generateUUID();
  }
  return {
    id,
    priceType: PriceType.DYNAMIC_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: {
      minimum: 1,
      maximum: 1
    },
    dynamicPriceOptions: {
      minPrice: String(min),
      maxPrice: String(max)
    }
  };
}
export const formatNumber = (input, locale) => {
  const filteredInput = input.replace(',', '.').match(/[\d.]+/);
  if (filteredInput) {
    const decimal = Math.floor(parseFloat(filteredInput[0]) * 100) / 100;
    const localizedNumber = localizeNumberInput(String(decimal), locale);
    return Number(localizedNumber);
  } else {
    return null;
  }
};
//# sourceMappingURL=payment-input-field-utils.js.map